export default "__VITE_ASSET__bb0fb825__"